import csv from './importers/csv.js';
import json from './importers/json.js';

export default {
	csv:csv,
	json:json,
};